export const appConfig = {
    // apiUrl: 'http://77.68.6.78:8080/', // for localhost
    // apiUrl: 'https://devtfyhub.uk:8081/', // for dev site
    apiUrl: 'https://tfyhub.com:8081/',
    // apiUrl: 'https://77.68.82.197/',
};
